module.exports = {
  footerText: 'Copyright Kone © 2020',
  pleaseWaitText: 'Please hold on, we are processing your request.',
  catchText: 'Due to technical reason, we are unable to process your request at this moment.'
}
